import { Component, Input, OnInit } from '@angular/core';
import { Menu } from '@app/interfaces/rm/resources';

@Component({
    selector: 'app-resource-select',
    templateUrl: './resource-select.component.html',
    styleUrls: ['./resource-select.component.less'],
})
export class ResourceSelectComponent implements OnInit {
    @Input() menus: Menu[] = [];
    constructor() {
    }

    ngOnInit(): void {
    }

    categoryChecked(selectItemIndex: number): void {
        const selectItem = this.menus[selectItemIndex];
        const { checked, children } = selectItem;
        selectItem.indeterminate = false;
        this.menus[selectItemIndex].children = children?.map(item => {
            return {
                ...item,
                checked,
                indeterminate: false,
            };
        }) || [];
    }

    menuChecked(selectMenuIndex: number): void {
        const selectItem = this.menus[selectMenuIndex];
        const { children } = selectItem;
        const allChecked = children?.every(item => item.checked);
        const someChecked = children?.some(item => item.checked);
        if (allChecked) {
            selectItem.indeterminate = false;
            selectItem.checked = true;
            return;
        }
        if (someChecked) {
            selectItem.indeterminate = true;
            selectItem.checked = false;
        } else {
            selectItem.indeterminate = false;
            selectItem.checked = false;
        }
    }

}
